module.exports = __webpack_public_path__ + "img/product.d25c9ca5.png";